import { useState } from 'react';

export const useFanTokenBreakdownCard = () => {
	const [isExpanded, setExpanded] = useState(false);

	const toggle = () => setExpanded(e => !e);

	return {
		isExpanded,
		toggle
	};
};
